'use client'

import { IconName } from '@dustin-web/microsite-components/src/icon'
import { Icon } from 'packages/microsite-components/src/icon-library'
import DustinLogo from '@dustin-web/microsite-components/src/dustin-logo'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import { useSiteContext, useTranslations } from 'packages/microsite-components/src/hooks'
import { useTrackingOnScreen } from '@dustin-web/microsite-components/src/on-screen/'

type ServiceCardProps = {
  customClass: string
  icon: IconName
  title: string
  content: string
  link: string
  eventName: string
}

const ManagedServicesLinks = {
  SE: '/solutions/managed-services',
  NO: '/tjenester/managed-services',
  DK: '/solutions/managed-services',
  FI: '/solutions/managed-services',
  NL: '/oplossingen/managed-services',
  BE: '',
}

const SoftwareMarketplaceLinks = {
  SE: '/solutions/software-services/software-marketplace',
  NO: '/tjenester/software-services/software-marketplace',
  DK: '/solutions/software-services/software-marketplace',
  FI: '/solutions/software-services/software-marketplace',
  NL: '/oplossingen/software-services/software-marketplace',
  BE: '',
}

const TakebackLinks = {
  SE: '/solutions/takeback',
  NO: '/tjenester/takeback',
  DK: '/solutions/takeback',
  FI: '/solutions/takeback',
  NL: '/oplossingen/takeback',
  BE: '',
}

const CloudLinks = {
  SE: '/solutions/managed-services/cloud',
  NO: '/tjenester/managed-services/cloud',
  DK: '/solutions/managed-services/cloud',
  FI: '/solutions/managed-services/cloud',
  NL: '/oplossingen/managed-services/cloud',
  BE: '',
}

const onClick = (selectedService: string) => {
  DigitalData.pushSelectPromotion({
    promotion_id: '',
    creative_name: selectedService,
    promotion_name: '',
    creative_slot: 'service_icons',
  })
}

const pushViewPromotion = (eventName: string) => {
  if (eventName) {
    DigitalData.pushViewPromotion({
      creative_name: eventName,
      promotion_name: '',
      creative_slot: 'service_icons',
      promotion_id: '',
    })
  }
}

const ServiceCard = ({ customClass, icon, title, content, link, eventName }: ServiceCardProps) => {
  const ref = useTrackingOnScreen(() => pushViewPromotion(eventName))

  return (
    <a
      href={link}
      onClick={() => {
        onClick(eventName)
      }}
      className={`service-card u-px-16 u-py-16 u-radius-8 col-span-1 ${customClass}`}>
      <div ref={ref} className="service-card-title u-mb-lg-8">
        <Icon name={icon} className="i-20 u-pr-8 u-pt-2" />
        <h4>{title}</h4>
      </div>
      <p className="u-fs-14 u-mb-40">{content}</p>
      <Icon className="i-20 service-card-arrow" name="arrow-right"></Icon>
    </a>
  )
}

export const ServicesAndSolutionsABtest = () => {
  const { translate } = useTranslations()
  const { sourcingCompany } = useSiteContext()

  return (
    <div className="u-bg-gray-02 u-pb-lg-40 u-pb-24 u-pt-lg-40 u-pt-24">
      <div className="container">
        <div className="u-radius-8 t-gray-09 u-pt-16 u-pt-lg-24 u-pb-16 u-px-16">
          <div className="d-lg-flex u-mb-24">
            <DustinLogo
              className="u-mr-16 u-mb-16 u-mb-lg-0"
              onlySymbol
              style={{ height: '32px', fill: '#FFFFFF' }}
            />
            <h2 className="u-fs-lg-28 u-fs-32 u-mb-0 u-color-white">
              {translate('Services_And_Solutions')}
            </h2>
          </div>
          <div className="services-and-solutions-area u-w-100">
            <ServiceCard
              customClass="t-dark-blue"
              eventName="managed-serivces"
              icon="services"
              link={ManagedServicesLinks[sourcingCompany]}
              title={translate('Managed_Services')}
              content={translate('Managed_Services_Text')}
            />
            <ServiceCard
              customClass="t-dark-brown"
              eventName="software-marketplace"
              icon="document-license"
              link={SoftwareMarketplaceLinks[sourcingCompany]}
              title={translate('Software_Marketplace')}
              content={translate('Software_Marketplace_Text')}
            />
            <ServiceCard
              customClass="t-dark-green"
              eventName="takeback"
              icon="leaf"
              link={TakebackLinks[sourcingCompany]}
              title={translate('Takeback')}
              content={translate('Takeback_Text')}
            />
            <ServiceCard
              customClass="t-gray-08"
              eventName="cloud"
              icon="cloud-2"
              link={CloudLinks[sourcingCompany]}
              title={translate('Cloud')}
              content={translate('Cloud_Text')}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
